import {isNil} from 'ramda';
import {isNilOrEmpty} from 'ramda-adjunct';

import {Nullish} from 'shared/web';

/** Mirror the backend SubjectNormalizer so an untouched prefill preserves the thread subject. */
const REPLY_PREFIX_PATTERN =
  /^(?:re|aw|antw|antwort|odp|sv|vs|vb|res|fwd|fw|wg|tr|r)\s*\.?\s*:\s*/iu;
// Separate counter-bearing markers to avoid nested repetition in the backend's regex.
const COUNTED_REPLY_PREFIX_PATTERN =
  /^(?:re|aw|antw|antwort|odp|sv|vs|vb|res|fwd|fw|wg|tr|r)\s*(?:\[\d+\]|\^\d+|\(\d+\))\s*\.?\s*:\s*/iu;
const TAG_PATTERN = /^\[[^\]]*\]\s*/u;
/** The marker written once; e-mail clients recognise the English form in every language. */
const REPLY_PREFIX = 'Re: ';

const stripReplyPrefixes = (subject: string) => {
  let rest = subject.trimStart();
  while (
    REPLY_PREFIX_PATTERN.test(rest) ||
    COUNTED_REPLY_PREFIX_PATTERN.test(rest) ||
    TAG_PATTERN.test(rest)
  ) {
    rest = rest
      .replace(REPLY_PREFIX_PATTERN, '')
      .replace(COUNTED_REPLY_PREFIX_PATTERN, '')
      .replace(TAG_PATTERN, '')
      .trimStart();
  }
  return rest.replace(/\s+/gu, ' ').trim();
};

export const toReplySubject = (subject: string | Nullish) => {
  const original = isNil(subject) ? '' : stripReplyPrefixes(subject);
  return isNilOrEmpty(original) ? undefined : `${REPLY_PREFIX}${original}`;
};
